import { Component, OnInit, Inject } from '@angular/core';
import { GenericTableComponent } from '../generic-components/generic-table/generic-table.component';
import { TableConfig } from '../generic-components/generic-table/class/TableConfig';
import { PageInformations } from '../generic-components/generic-table/class/PageInformations';
import { NgxSpinnerService } from 'ngx-spinner';
import { GenericSearchService } from '../generic-components/generic-search/generic-search.service';
import { PageEvent } from '@angular/material/paginator';
import { SyncroLog } from '../models/SyncroLog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'app-sync-err',
  imports: [GenericTableComponent,MatCardModule],
  templateUrl: './sync-err.component.html',
  styleUrl: './sync-err.component.css',
})
export class SyncErrComponent implements OnInit {
  listSyncroLogs: SyncroLog[] = [];

  pageInformations: PageInformations = new PageInformations();

  emitClickRow = 'details';

  idSyncro!: number

  searchQuery: string = "";

  tableConfig: TableConfig = {
    columns: [
      {
        id: 'id',
        libelle: 'ID',
        property: 'id',
        researchable: false,
      },
      {
        id: 'dateErreur',
        libelle: "Date de l'erreur",
        property: 'dateErreur',
        type: 'date',
        researchable: true,
      },
      {
        id: 'type',
        libelle: 'Type',
        property: 'type',
        searchOn: 'type',
        researchable: true,
      },
      {
        id: 'message',
        libelle: 'Message',
        property: 'message',
        researchable: true,
      }
    ],
  };

  constructor(
    private searchService: GenericSearchService,
    private spinner: NgxSpinnerService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.idSyncro = data.idSyncro;
  }

  ngOnInit(): void {
    this.loadSyncroLogs();
  }
  pageEvent(event: PageEvent) {
    this.pageInformations.pageIndex = event.pageIndex;
    this.pageInformations.pageSize = event.pageSize;
    this.loadSyncroLogs();
  }



  loadSyncroLogs(): void {
    this.spinner.show();

    let query: string = 'syncro.idSyncro=='+this.idSyncro

    this.searchService
      .search(
        'syncro/log',
        query,
        this.pageInformations.pageIndex,
        this.pageInformations.size,
        ''
      )
      .subscribe(
        (res: any) => {
          this.spinner.hide();
          this.listSyncroLogs = res.content;
          this.pageInformations = this.searchService.updatePageInformations(
            this.pageInformations,
            res
          );
        },
        (error) => {
          this.spinner.hide();
        }
      );
  }



}
